import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
import { AudioProvider } from '../context/AudioContext';
import { BookingProvider } from '../context/BookingContext';
import { LenisProvider } from '../providers/LenisProvider';
import { BookingModal } from './BookingModal';
import { CursorTracker } from './CursorTracker';
import { Footer } from './Footer';
import { Navbar } from './Navbar';
import { PageTransition } from './PageTransition';

export function RootLayout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  }, [location.pathname]);

  return (
    <AudioProvider>
    <BookingProvider>
      <LenisProvider>
        <div className="relative min-h-screen flex flex-col">
          <Navbar />
          <main className="flex-1">
            <PageTransition>
              <Outlet />
            </PageTransition>
          </main>
          <Footer />
        </div>
        <div aria-hidden className="grain-overlay" />
        <BookingModal />
        <CursorTracker />
      </LenisProvider>
    </BookingProvider>
    </AudioProvider>
  );
}
